module.exports = __webpack_public_path__ + "static/media/premium_perspective.c92e6049.jpg";